/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ShoppingCartPreOrderBookListBookItemDto model module.
 * @module model/ShoppingCartPreOrderBookListBookItemDto
 * @version v1.0.0
 */
class ShoppingCartPreOrderBookListBookItemDto {
    /**
     * Constructs a new <code>ShoppingCartPreOrderBookListBookItemDto</code>.
     * @alias module:model/ShoppingCartPreOrderBookListBookItemDto
     */
    constructor() { 
        
        ShoppingCartPreOrderBookListBookItemDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ShoppingCartPreOrderBookListBookItemDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ShoppingCartPreOrderBookListBookItemDto} obj Optional instance to populate.
     * @return {module:model/ShoppingCartPreOrderBookListBookItemDto} The populated <code>ShoppingCartPreOrderBookListBookItemDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ShoppingCartPreOrderBookListBookItemDto();

            if (data.hasOwnProperty('annual')) {
                obj['annual'] = ApiClient.convertToType(data['annual'], 'String');
            }
            if (data.hasOwnProperty('bookName')) {
                obj['bookName'] = ApiClient.convertToType(data['bookName'], 'String');
            }
            if (data.hasOwnProperty('bookPrice')) {
                obj['bookPrice'] = ApiClient.convertToType(data['bookPrice'], 'Number');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} annual
 */
ShoppingCartPreOrderBookListBookItemDto.prototype['annual'] = undefined;

/**
 * @member {String} bookName
 */
ShoppingCartPreOrderBookListBookItemDto.prototype['bookName'] = undefined;

/**
 * @member {Number} bookPrice
 */
ShoppingCartPreOrderBookListBookItemDto.prototype['bookPrice'] = undefined;

/**
 * @member {Number} quantity
 */
ShoppingCartPreOrderBookListBookItemDto.prototype['quantity'] = undefined;






export default ShoppingCartPreOrderBookListBookItemDto;

